var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSsnCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149,
    height: 94,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 90,
    stroke: "#043F93",
    strokeWidth: 3,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3D8EBB",
    strokeLinecap: "square",
    strokeWidth: 3,
    d: "M1 26c20.37977-6.66667 44.2131-10 71.5-10 27.2869 0 51.12023 3.33333 71.5 10M137 24.7619v62.55048M128 22.78571V87.2909"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3D8EBB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M35.62293 72.93607h74.75412"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3D8EBB",
    strokeLinecap: "square",
    strokeWidth: 3,
    d: "M17 22.78571V87.2909M8 24.7619v62.55048"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3D8EBB",
    transform: "translate(33 45)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 2.5,
    r: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsnCard);
export default __webpack_public_path__ + "static/media/ssn-card.dbea72511aa55a0a5011f980ceaa8b80.svg";
export { ForwardRef as ReactComponent };